
import { Box, Chip, Stack } from "@mui/material";
import { Typography } from "components/ui";
import React from "react";

const BottleHeader = ({ roomCode, userName, drinkType, myPrivileges }) => {
    return (
        <Box sx={{ px: 2, mb: 2 }}>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 2,
                }}
            >
                <Box>
                    <Typography $size="0.9em" color="textSecondary">
                        ROOM
                    </Typography>
                    <Typography $size="1.2em" $bolds color="primary">
                        {roomCode}
                    </Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Typography $size="2.5em" $bolds>
                        {userName}
                    </Typography>
                    <Chip
                        label={drinkType}
                        size="small"
                        color={drinkType === "เบียร์" ? "success" : "primary"}
                    />
                </Box>
            </Box>
            <Stack
                direction="row"
                spacing={2}
                justifyContent="center"
                sx={{ mt: 1 }}
            >
                <Chip
                    label={`📝 ${myPrivileges?.addQ || 0}`}
                    color="info"
                    sx={{ fontSize: "2em", fontWeight: "bold", p: 3 }}
                />
                <Chip
                    label={`🛡️ ${myPrivileges?.skipD || 0}`}
                    color="warning"
                    sx={{ fontSize: "2em", fontWeight: "bold", p: 3 }}
                />
            </Stack>
        </Box>
    );
};

export default BottleHeader;
